
module.constant('AffnetReportDefinitions', {
    order: ['hse', 'placement', 'litnum', 'certification', 'retention',
            'completion', 'attendance', 'vote'],

    completion: {
        title: 'Completion & Attendance',
        dialTitle: 'Completion',
        excludeReason: 'have not exited',
        helpNumerator: "Number of students who successfully exited YouthBuild",
        helpDenominator: "All exited students.",
        helpExtra: '**Attendance** is calculated by averaging the attendance of all ' +
                   'exited students, adjusting by the number of days they were ' +
                   'enrolled.',
        standards: {
            high: 'Above 75%',
            good: '75%',
            attn: '55% - 75%',
            bad: 'Below 55%',
        },
        columns: [
            {
                label: 'Completion',
                numeratorText: 'completed successfully',
                denominatorText: 'exited program',
                width: 'w3'
            },
            {
                name: 'attendance',
                label: 'Attendance',
                width: 'w2'
            },
        ]
    },

    certification: {
        title: 'Certification',
        helpNumerator: 'Number of students who earned an industry recognized ' +
                       'or foundational certification after entry into YouthBuild.',
        helpDenominator: "All Enrollees",
        standards: {
            high: 'Above 75%',
            good: '75%',
            attn: '50% - 75%',
            bad: 'Below 50%',
        },
        columns: [
            {
                name: null,
                label: 'Earned Certificate',
                numeratorText: 'earned a certification'
            },
            {
                name: 'irc',
                label: 'Industry Recognized',
                numeratorText: 'earned an Industry Recognized Certification'
            },
            {
                name: 'foundational',
                label: 'Foundational',
                numeratorText: 'earned a Foundational Certification',
            },
        ]
    },

    hse: {
        title: 'HSE / Diploma',
        helpNumerator: "Number of students who received a diploma or HSE " +
                       "between entry into the program up to one year after exit.",
        helpDenominator: "All enrollees who did not have a diploma or HSE at entry.",
        excludeReason: 'enrolled with an HSE or Diploma',
        standards: {
            high: 'Above 50%',
            good: '50%',
            attn: '30% - 50%',
            bad: 'Below 30%',
        },
        columns:[
            {
                label: 'Either Credential',
                numeratorText: 'earned a diploma or HSE',
                denominatorText: 'enrolled without a diploma or HSE',
            },
            {
                name: 'diploma',
                label: 'High School Diploma',
                numeratorText: 'earned a diploma',
                denominatorText: 'enrolled without a diploma or HSE',
                icon: 'graduation-cap',
            },
            {
                name: 'hse',
                label: 'High School Equivalency',
                numeratorText: 'earned an HSE',
                denominatorText: 'enrolled without a diploma or HSE',
                icon: 'graduation-cap',
            },
        ],
    },

    litnum: {
        title: 'Literacy / Numeracy',
        excludeReason: 'enrolled with both reading and math grade levels above 10',
        helpNumerator: 'Number of students who increased at least 2 grade ' +
                       'levels in either reading or math.',
        helpDenominator: 'All enrollees who enrolled with either a reading or ' +
                         'math grade level at grade 10 or below.',
        standards: {
            high: 'Above 75%',
            good: '75%',
            attn: '50% - 75%',
            bad: 'Below 50%',
        },
        columns: [
            {
                label: 'Gained Either',
                numeratorText: 'gained 2 grade levels in reading or math',
                denominatorText: 'enrolled with reading or math grade 10 or below',
            },
            {
                name: 'reading',
                label: 'Gained Reading',
                numeratorText: 'gained 2 grade levels in reading',
                denominatorText: 'enrolled with reading grade level 10 or below'
            },
            {
                name: 'math',
                label: "Gained Math",
                numeratorText: 'gained 2 grade levels in math',
                denominatorText: 'enrolled with math grade level 10 or below'
            }
        ]
    },

    placement: {
        title: 'Placement',
        excludeReason: 'are still active in your program',
        helpNumerator: 'Number of students placed in either their exit ' +
                       'quarter or first quarter after exit in employment, ' +
                       ' continuing education, or both.',
        helpDenominator: 'All Exits',
        standards: {
            high: 'Above 55%',
            good: '55%',
            attn: '35% - 55%',
            bad: 'Below 35%',
        },
        columns: [
            {
                label: 'Placed',
                numeratorText: 'placed during their exit quarter or first quarter after exit',
                denominatorText: 'exited program',
            },
            {
                name: 'education',
                label: 'Education',
                numeratorText: 'placed in education during their exit quarter or first quarter after exit',
                denominatorText: 'exited program',
            },
            {
                name: 'job',
                label: 'Job',
                numeratorText: 'placed a job during their exit quarter or first quarter after exit',
                denominatorText: 'exited program',
            },
        ],
    },

    retention: {
        title: 'Retention in Placement',
        dialTitle: 'Retention',
        excludeReason: 'were not placed during their exit quarter or first quarter after exit',
        helpNumerator: 'Students who were placed during their exit quarter or ' +
                       'first quarter after exit, and remained placed for 3 ' +
                       'successive quarters',
        helpDenominator: 'Students placed during their exit quarter or ' +
                         'first quarter after exit',
       standards: {
            high: 'Above 65%',
            good: '65%',
            attn: '47% - 65%',
            bad: 'Below 47%',
        },
        columns: [
            {
                label: 'Placement Retention',
                numeratorText: 'placed in three successive quarters',
                denominatorText: 'placed during their exit quarter or first quarter after exit',
                width: "w3",
            },
            {
                name: 'exit',
                label: 'Retention of Those Placed in Exit Quarter',
                numeratorText: 'placed in their exit quarter and retained placement',
                denominatorText: 'placed during their exit quarter or first quarter after exit',
                width: "w2",
            },
            {
                name: 'first',
                label: 'Retention of Those Placed First Quarter After Exit',
                numeratorText: 'placed in the first quarter after exit and retained placement',
                denominatorText: 'placed during their exit quarter or first quarter after exit',
                width: "w2",
            },
        ]
    },

    attendance: {
        title: 'Attendance',
        reportLink: 'completion',
        standards: {
            high: 'Above 80%',
            good: '80%',
            attn: '70% - 80%',
            bad: 'Below 70%',
        },
        columns: [
            {
                label: 'Attendance',
                numeratorText: 'Attendance',
            }
        ]
    },

    vote: {
        title: 'Voter Registration',
        excludeReason: 'are not eligible to vote',
        helpNumerator: 'Students registered to vote',
        helpDenominator: 'Students eligible to vote',
        standards: {
            high: 'Above 80%',
            good: '80%',
            attn: '70% - 80%',
            bad: 'Below 70%',
        },
        columns: [
            {
                label: 'Registered',
                numeratorText: 'registered to vote',
                denominatorText: 'eligible to vote'
            },
            {
                name: 'unknown',
                label: 'Unknown',
                numeratorText: 'with unknown voter status',
                denominatorText: ' ',
            },
        ]
    },

    wage: {
        title: 'Wage',
        // programTemplate: 'reports/affnet/wagePrograms',
        excludeReason: 'do not have a job placement in their exit quarter or one quarter after exit',
        helpNumerator: "Average wage of jobs in the student's exit quarter or one quarter after exit",
        helpDenominator: "State Minimum Wage",
        helpDenominatorCaption: "*Minimum wage as of 2.20.21",
        standards: {
            high: 'Above 124% of min wage',
            attn: '100% - 123% of min wage',
            bad: 'Below min wage',
        },
        columns: [
            {
                label: 'Percent Above Minimum Wage',
                percentText: 'above minimum wage',
            },
            {
                name: 'wage',
                label: 'Average Hourly Wage',
                literal: 'wage',
            },
        ]
    },

    recidivism: {
        title: 'Recidivism',
        excludeReason: 'were not offenders at entry',
        helpNumerator: 'Students who were convicted of a new crime or violated ' +
                       'parole within one year of entry',
        helpDenominator: 'Students who were youth or adult offenders at entry.',
        standards: {
            high: 'Below 15%',
            good: '15%',
            attn: '16% - 25%',
            bad: 'Above 25%',
        },
        columns: [
            {
                label: 'Recidivism',
                denominatorText: 'were offenders at entry',
                numeratorText: 'reoffended before 1 year after entry',
            },
            {
                name: 'offender',
                label: 'Offender at Entry',
                denominatorText: 'match filters',
                numeratorText: 'were offenders at entry',
            },
        ]
    },
});
